var openedTopModel = false;
/*
$(window).load(function(){    
  var key = 'hadModal';
  var hadModal = localStorage.getItem(key);

  if (!hadModal && !openedTopModel) {
     setTimeout(function(){
   		openMidModal();
        localStorage.setItem(key, true);
     }, 5000);      
  }

});  
*/

function openTopModal(){
  closeMidModal();
  openOfferModal('topModal');	
}

function openMidModal(){
	$("#midModal").removeClass("collapse");
}

function closeMidModal(){
	$("#midModal").addClass("collapse");
}

function openOfferModal(modalId){
   var errorMessageId = modalId + "ErrorMessage";
   var emailId = modalId + "Email";
  
	$("#"+ emailId).val("");  	
  	$("#"+ emailId).removeClass("inv-error");
  	$("#"+ errorMessageId).hide();
  
    if(modalId == 'topModal'){
    	openedTopModel = true;
    }
  	$('#' + modalId).modal("show");
}

function closeModal(modalId){
	$('#' + modalId).modal("hide");  
}

function emailOffer(modalId){
  var isValid = validateOfferEmail(modalId);
  if(isValid){      
    var toEmail = $("#"+ modalId +"Email").val().trim();  
    var klaviyoKey = $("#KlaviyoPublicKey").val();
   
    const options = {
      method: 'POST',
      headers: {Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams({
        data: '{"token": "'+ klaviyoKey +'", "event": "Innova Exclusive Offers", "customer_properties": {"$email": "'+ toEmail +'"}}'
      })
    };

    fetch('https://a.klaviyo.com/api/track', options)
      .then(response => response.json())
      .then(response => console.log(response))
      .catch(err => console.error(err));
   
    if(modalId == 'topModal'){
     	$('#' + modalId).modal("hide");  
    }else{
    	closeMidModal();
    }
     $('#emailMsgModal').modal("show");  
  }  
    
  
  return false;
}

function validateOfferEmail(modalId){
  var isValid = checkRequiredFields(modalId + "EmailForm");  
  var errorMsg = "";
  var errorMessageId = modalId + "ErrorMessage";
  
  $("#" + errorMessageId).hide();
  
  if(!isValid){
  	errorMsg = "Email is required and must be filled out.";
  }
  
  if(!IsEmail()){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Email entered is invalid or incorrect, please enter a valid email address.";
  }  
  
  if(errorMsg != ""){
  	$("#" + errorMessageId).html(errorMsg);
    $("#" + errorMessageId).show();
  }
  
  return (errorMsg == "");
}
